import { render, staticRenderFns } from "./PortfolioTotalNetPremium.vue?vue&type=template&id=8ad69566&scoped=true&"
var script = {}
import style0 from "./PortfolioTotalNetPremium.vue?vue&type=style&index=0&id=8ad69566&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad69566",
  null
  
)

export default component.exports